import { Component, Inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from '../../auto-unsubscribe.decorator';
import { FormFieldError } from '../uix-forms.utils';
import { FormFieldDateComponent } from '../form-field-date/form-field-date.component';

@AutoUnsubscribe()
@Component({
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, TranslatePipe],
  selector: 'app-form-field-date-range',
  templateUrl: './form-field-date-range.component.html',
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
  standalone: true,
})
export class FormFieldDateRangeComponent extends FormFieldDateComponent {
  @Input()
  fieldEnd: string;

  constructor(
    protected readonly adapter: DateAdapter<unknown>,
    @Inject(MAT_DATE_LOCALE) protected locale: string,
    protected readonly translate: TranslateService,
  ) {
    super(adapter, locale, translate);
  }

  // Only displays the first error in Mat-error.
  displayedErrors(): FormFieldError[] {
    const fromField = this.formGroup.controls[this.field];
    const toField = this.formGroup.controls[this.fieldEnd];
    return this.errors
      .filter((e: FormFieldError) => {
        return fromField.hasError(e.error) || toField.hasError(e.error);
      })
      .slice(0, 1);
  }
}
